'use strict';

var React = require('react');

const isFunction = (value)=>{
    return typeof value === "function";
};
const hasValue = (controlledOptions)=>{
    return typeof controlledOptions?.value !== "undefined";
};
/**
 * A hook used to manage controlled state.
 * It can be used to manage state that is controlled by the parent component.
 * It can also be used to manage state that is uncontrolled by the parent component.
 *
 * @example
 * ```tsx
 * const [state, setState] = useControlledState(initialState, controlledOptions);
 * ```
 */ const useControlledState = (initialState, controlledOptions)=>{
    const [uncontrolledState, setUncontrolledState] = React.useState(initialState);
    if (hasValue(controlledOptions)) {
        const setValue = (value)=>{
            if (controlledOptions.setValue) {
                // Handle both simple and complex setValue functions
                const resolvedValue = typeof value === "function" ? value(controlledOptions.value) : value;
                controlledOptions.setValue(resolvedValue);
            }
            setUncontrolledState(value);
        };
        if (isFunction(controlledOptions.value)) {
            return [
                controlledOptions.value(),
                setValue
            ];
        }
        return [
            controlledOptions.value,
            setValue
        ];
    }
    return [
        uncontrolledState,
        setUncontrolledState
    ];
};

exports.useControlledState = useControlledState;
//# sourceMappingURL=useControlledState.cjs.map
